/*
    设备平均效率对比
    lxx  2021-4-14
*/
<template>
    <div class="EquipmentEfficiency mainWrap" v-loading.fullscreen.lock="fullscreenLoading">
        <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
            <!-- 左边导航栏 -->
            <el-aside style="width:auto;">
                <leftNav msg="/EquipmentEfficiency"></leftNav>
            </el-aside>
            <!-- 右侧主体部分 -->
            <el-container>
                <el-main style="overflow: hidden;">
                    <div class="mainWrao">
                        <div class="recordTitle">
                            <h1>{{$t('leftNav.navTwentyFive')}}</h1>
                        </div>
                        <div class="tableWrap">
                            <div class="times">
                                <el-date-picker
                                    v-model="datePicker"
                                    type="datetimerange"
                                    :editable="editable"
                                    @change="changeTime"
                                    :picker-options="pickerOptions"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    range-separator="~"
                                    :start-placeholder="$t('MachineDashBoard.StartTime')"
                                    :end-placeholder="$t('MachineDashBoard.EndTime')"
                                    align="left"
                                    >
                                </el-date-picker>
                                <div class="chooseButton">
                                    <el-popover
                                        v-model="visible1"
                                        placement="bottom"
                                        width="500"
                                        @after-leave="hideMachine()"
                                        trigger="click"
                                        ref="popover1">
                                        <!-- <div class="noMachine" v-if="activemachineList.length==0">{{$t('Dailyequipment.noEquipmentData')}}</div> -->
                                        <!-- <ul class="machineList" v-else> -->
                                        <div class="noMachine" v-if="machineList.length==0">{{$t('EquipmentEfficiency.error5')}}</div>
                                        <div v-else>
                                            <ul class="machineList">
                                                <li @click="selectmachineId(all)" :class="{'active':selectmachine[0].value==''}">{{$t('PartsFaultAlarm.all')}}</li>
                                                <!-- css选中项反显，原使用includes()，进行判断，但会有问题，改为调用方法，循环判断 -->
                                                <!-- <li v-for="(item,index) in machineList" :class="{'active':selectmachine.includes(item)}" :key="item.value" @click="selectmachineId(item)"  :title="item.label">{{item.label}}</li> -->
                                                <li v-for="item1 in machineList" :class="{'active':isActiveMachine(item1)}" :key="item1.value" @click="selectmachineId(item1)"  :title="item1.label">{{item1.label}}</li>
                                            </ul>
                                            <div style="text-align: right; margin: 0">
                                                <el-button type="primary" size="mini" @click="clickmachine">{{$t('EquipmentEfficiency.button1')}}</el-button>
                                            </div> 
                                        </div>
                                        <el-button type="primary" slot="reference">{{$t('EquipmentEfficiency.chooseEquipment')}}</el-button>                                 
                                    </el-popover>
                                    <!-- <el-button type="primary" v-popover:popover1>{{$t('EquipmentEfficiency.chooseEquipment')}}</el-button> -->
                                    <div v-loading="loading" style="margin-left:20px;">
                                        <el-popover
                                            v-model="visible2"
                                            placement="bottom"
                                            width="300"
                                            @after-leave="hideRecipe"
                                            popper-class="recipePopper"
                                            trigger="click"
                                            ref="popover2">
                                            <div class="noMachine" v-if="noRecord==1">{{$t('EquipmentEfficiency.error3')}}</div>
                                            <div class="noMachine" v-else-if="noRecord==2">{{$t('EquipmentEfficiency.error4')}}</div>
                                            <div v-else>
                                                <el-scrollbar class="machineWrap" style="height:85%;width:100%;">
                                                    <ul class="machineList recipeList">
                                                        <li @click="selectRecipeId(allRecipe)" :class="{'active':selectRecipe[0].value==''}" style="text-align:center;">{{$t('PartsFaultAlarm.all')}}</li>
                                                        <!-- <li v-for="(item,index) in recipeList" :class="{'active':selectRecipe.includes(item)}" :key="item.value" @click="selectRecipeId(item)"  :title="item.label">{{item.label}}</li> -->
                                                        <li v-for="item2 in recipeList" :class="{'active':isActiveRecipe(item2)}" :key="item2.value" @click="selectRecipeId(item2)"  :title="item2.label">{{item2.label}}</li>
                                                    </ul>
                                                </el-scrollbar>
                                                <div style="text-align: right; margin-top: 8px;">
                                                    <el-button type="primary" size="mini" @click="clickrecipe">{{$t('EquipmentEfficiency.button1')}}</el-button>
                                                </div>
                                            </div>
                                            <el-button type="primary" slot="reference" @click="checkRecipeBtn">{{$t('EquipmentEfficiency.chooseRecipe')}}</el-button>
                                        </el-popover>
                                    </div>
                                </div>
                            </div>
                            <el-button type="primary" style="float:right;" icon="el-icon-view" @click="getTableInfo()">{{$t('StepCycleTime.showBtn')}}</el-button>
                        </div>
                        <div class="EquipmentEfficiencyTable">
                            <el-table
                                :header-cell-style="{background:'#fff',color:'#606266'}"
                                :data="tableData"
                                fit
                                height="98%"
                                :span-method="objectSpanMethod"
                                :empty-text="$t('WorkShopDashBoard.noEquipmentTableMessage')"
                                style="width: 95%;margin:10px auto;">
                                <el-table-column
                                    prop="equipmentName"
                                    :label="$t('EquipmentEfficiency.tableTitle1')"
                                    align="center"
                                    width="120">
                                </el-table-column>
                                <el-table-column :label="$t('EquipmentEfficiency.tableTitle2')" align="center">
                                    <el-table-column
                                        align="center"
                                        :label="$t('EquipmentEfficiency.tableTitle3')"
                                        min-width="340"
                                    >
                                        <template slot-scope="scope" >
                                            <div v-if="scope.$index % 2 ==0" style="text-align:center;">{{scope.row.one.CC.alltime}}</div>
                                            <div class="ccbox" v-if="scope.$index % 2 !=0"><span style="margin:auto">{{$t('EquipmentEfficiency.tableTitle6')+scope.row.two.CC.equipmentTime}}</span></div>
                                            <div class="ccboxRight" v-if="scope.$index % 2 !=0">{{$t('EquipmentEfficiency.tableTitle7')+scope.row.two.CC.operatorTime}}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        align="center"
                                        :label="$t('EquipmentEfficiency.tableTitle4')"
                                        min-width="340"
                                    >
                                        <template slot-scope="scope" >
                                            <div v-if="scope.$index % 2 ==0">{{scope.row.one.BT.alltime}}</div>
                                            <div class="ccbox" v-if="scope.$index % 2 !=0">{{$t('EquipmentEfficiency.tableTitle6')+scope.row.two.BT.equipmentTime}}</div>
                                            <div class="ccboxRight" v-if="scope.$index % 2 !=0">{{$t('EquipmentEfficiency.tableTitle7')+scope.row.two.BT.operatorTime}}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        align="center"
                                        :label="$t('EquipmentEfficiency.tableTitle5')"
                                        min-width="525"
                                    >
                                        <template slot-scope="scope" >
                                            <div v-if="scope.$index % 2 ==0">{{scope.row.one.SP.alltime}}</div>
                                            <div class="ccbox newGtime" v-if="scope.$index % 2 !=0">{{$t('EquipmentEfficiency.tableTitle6')+scope.row.two.SP.equipmentTime}}</div>
                                            <div class="ccboxRight newGtime" v-if="scope.$index % 2 !=0">{{$t('EquipmentEfficiency.tableTitle7')+scope.row.two.SP.operatorTime}}</div>
                                            <div class="ccboxRight newGtime" v-if="scope.$index % 2 !=0">{{$t('EquipmentEfficiency.tableTitle8')+scope.row.two.SP.rollingTime}}</div>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    :label="$t('EquipmentEfficiency.tableTitle9')"
                                    min-width="280">
                                    <template slot-scope="scope">
                                        <div style="display:flex; flex-direction:column;line-height:20px">
                                            <div v-for="(item,index) in scope.row.recipe" :key="index">{{item}}</div>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import { formatDate } from '../assets/js/date.js'
import leftNav from "@/components/nav.vue"
export default {
    name: 'EquipmentEfficiency',
    components: {
        leftNav
    },
    data(){
        return{
            fullscreenLoading: false,
            loading:false,
            //选择的时间
            datePicker:[],
            pickerMinDate: '',
            //选中的时间开始时间与结束时间
            startTimePicker:'',
            endTimePicker:'',
            editable:false,
            // 时间快捷键
            pickerOptions: {
                onPick: ({minDate}) => {
                    this.pickerMinDate = minDate.getTime()
                },
                disabledDate: (time) =>{
                    if (this.pickerMinDate !== '') {
                        const day7 = 7 * 24 * 3600 * 1000
                        let maxTime = this.pickerMinDate + day7
                        let minTime = this.pickerMinDate - day7
                        return (time.getTime() > maxTime || time.getTime() < minTime)
                    }else {
                        return ''
                    }
                },
                shortcuts: [{
                    text: this.$t('MachineDashBoard.pickTime1'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 1);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: this.$t('MachineDashBoard.pickTime2'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 3);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: this.$t('MachineDashBoard.pickTime3'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 8);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            visible1:false,
            visible2:false,
            disabledFlag:false,
            //设备选项
            machineList:[],
            //设备上次选中项
            selectBeforeMachine:[{label:"全部",value:''}],
            //设备选中项
            selectmachine:[{label:"全部",value:''}],
            //设备提交项
            choosedmachine:'',
            all:{label:"全部",value:''},
            //规格选项
            recipeList:[],
            //规格上次选中项
            selectBeforeRecipe:[{label:"全部",value:''}],
            //规格选中项
            selectRecipe:[{label:"全部",value:''}],
            //规格提交项
            choosedRecipe:'',
            allRecipe:{label:"全部",value:''},
            tableData:[],
            noRecord:0 //1是查询范围内无结果，2是未记录
        }
    },
    computed: {
        islangChange () {
            return this.$store.state.lang
        }
    },
    watch: {
        islangChange (curval, oldval) {
            if (curval != oldval) {
                this.$nextTick(()=>{
                    this.$parent.reload()
                })
            }
        },  
    },
    mounted () {
        if (this.$store.state.reloadState === false) {
          this.$store.state.reloadState = true
          this.$parent.reload()
        }else{
            this.getmachineList()
            this.getTableInfo()
        }
    },
    methods:{
        //筛选规格框隐藏后
        hideRecipe(){
            let selectRecipes=this.selectRecipe.map(function(obj,index){
                return obj.label;
            }).join(",");
            if(selectRecipes!=this.choosedRecipe)this.selectRecipe=this.selectBeforeRecipe
        },
        //筛选机器框隐藏后
        hideMachine(){
            let selectmachines=this.selectmachine.map(function(obj,index){
                return obj.value;
            }).join(",");
            //若本次选择与选中项(即未确认)不同,恢复到之前选中项
            if(selectmachines!=this.choosedmachine)this.selectmachine=this.selectBeforeMachine
        },
        //machine判断是否选中
        isActiveMachine(chooseOne){
            for(let j=0;j<this.selectmachine.length;j++){
                if(this.selectmachine[j].value==chooseOne.value && this.selectmachine[j].label==chooseOne.label)return true
            }
        },
        //判断recipe是否选中
        isActiveRecipe(chooseOne){
            for(let j=0;j<this.selectRecipe.length;j++){
                if(this.selectRecipe[j].value==chooseOne.value && this.selectRecipe[j].label==chooseOne.label)return true
            } 
        },
        //合并单元格
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                if (rowIndex % 2 === 0) {
                    return {
                        rowspan: 2,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
            if (columnIndex === 4) {
                if (rowIndex % 2 === 0) {
                    return {
                        rowspan: 2,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        },
        s_to_hs(s){
            //计算分钟
            //算法：将秒数除以60，然后下舍入，既得到分钟数
            var h;
            h  =   Math.floor(s/60);
            //计算秒
            //算法：取得秒%60的余数，既得到秒数
            s  =   Math.round(s%60);
            //将变量转换为字符串
            h    +=    '';
            s    +=    '';
            return h+'min'+s+'s';
        },
        // 切换计算周期的时间
        changeTime(){
            // this.recipeList=[]
            if (this.datePicker === null) {
                this.startTimePicker=''
                this.endTimePicker=''
                this.pickerMinDate = ''
                this.getRecipeList()
            }else if(this.datePicker!=null){
                this.startTimePicker=this.datePicker[0]
                this.endTimePicker=this.datePicker[1]
                this.getRecipeList()
            }
        },
        // 获取机械列表
        getmachineList(){
            let _this = this
            this.axios({
                method: 'get',
                url: '/url/getMachineList'
            }).then(function(res){
                if (res.data.success === true){
                    let machineContent=res.data.data
                    for(let i = 0; i < machineContent.length; i++) {
                        let machineInfo={label:machineContent[i].equipmentName+'('+machineContent[i].nameZh+')',value:machineContent[i].id}
                        _this.machineList.push(machineInfo)
                    }
                }else{
                    _this.$message.error(res.data.msg);
                }
            })  
        },
        //获取表格数据
        getTableInfo(){
            let _this = this
            _this.fullscreenLoading = true
            _this.tableData=[]
            let data={language: this.$store.state.lang}
            if(this.datePicker!=null){
                if(this.datePicker.length!=0){
                    let key1 = "startDate";
                    data[key1] = this.startTimePicker;
                    let key2 = "endDate";
                    data[key2] = this.endTimePicker;
                }
            }
            if(this.choosedmachine !== null &&this.choosedmachine !== undefined &&this.choosedmachine !== ''){
                let key3 = "machineIds";
                data[key3] = this.choosedmachine;
            }
            if(this.choosedRecipe !== null &&this.choosedRecipe !== undefined &&this.choosedRecipe !== '' &&this.choosedRecipe !== '全部'){
                let key4 = "recipes";
                data[key4] = this.choosedRecipe;
            }
            this.axios({
                method: 'POST',
                timeout: 300000,
                url: '/url/getAverageEfficiencyData',
                params: data
            }).then(function (res) {
                if (res.data.success === true) {
                    _this.tableData=res.data.data
                    if('startTime' in res.data && 'endTime' in res.data ){
                        let startTime=res.data.startTime
                        let endTime=res.data.endTime
                        _this.datePicker = [formatDate(new Date(startTime), 'yyyy-MM-dd hh:mm:ss'),formatDate(new Date(endTime), 'yyyy-MM-dd hh:mm:ss')]
                        _this.startTimePicker=_this.datePicker[0]
                        _this.endTimePicker=_this.datePicker[1]
                        _this.getRecipeList()
                        
                    }
                    _this.tableData.forEach(element => {
                        if(element.one.BT.alltime){
                            if(element.one.BT.alltime>=300){
                                element.one.BT.alltime = _this.s_to_hs(element.one.BT.alltime)
                            }else{
                                element.one.BT.alltime = element.one.BT.alltime+'s'
                            }
                        }else{
                            element.one.BT.alltime='-s'
                        }
                        if(element.one.CC.alltime){
                            if(element.one.CC.alltime>=300){
                                element.one.CC.alltime = _this.s_to_hs(element.one.CC.alltime)
                            }else{
                                element.one.CC.alltime = element.one.CC.alltime+'s'
                            }
                        }else{
                            element.one.CC.alltime='-s'
                        }
                        if(element.one.SP.alltime){
                            if(element.one.SP.alltime>=300){
                                element.one.SP.alltime = _this.s_to_hs(element.one.SP.alltime)
                            }else{
                                element.one.SP.alltime = element.one.SP.alltime+'s'
                            }
                        }else{
                            element.one.SP.alltime='-s'
                        }
                        if(element.two.BT.equipmentTime){
                            if(element.two.BT.equipmentTime>=300){
                                element.two.BT.equipmentTime = _this.s_to_hs(element.two.BT.equipmentTime)
                            }else{
                                element.two.BT.equipmentTime = element.two.BT.equipmentTime+'s'
                            }
                        }else{
                            element.two.BT.equipmentTime='-s'
                        }
                        if(element.two.BT.operatorTime){
                            if(element.two.BT.operatorTime>=300){
                                element.two.BT.operatorTime = _this.s_to_hs(element.two.BT.operatorTime)
                            }else{
                                element.two.BT.operatorTime = element.two.BT.operatorTime+'s'
                            }
                        }else{
                            element.two.BT.operatorTime='-s'
                        }
                        if(element.two.CC.equipmentTime){
                            if(element.two.CC.equipmentTime>=300){
                                element.two.CC.equipmentTime = _this.s_to_hs(element.two.CC.equipmentTime)
                            }else{
                                element.two.CC.equipmentTime = element.two.CC.equipmentTime+'s'
                            }
                        }else{
                            element.two.CC.equipmentTime='-s'
                        }
                        if(element.two.CC.operatorTime){
                            if(element.two.CC.operatorTime>=300){
                                element.two.CC.operatorTime = _this.s_to_hs(element.two.CC.operatorTime)
                            }else{
                                element.two.CC.operatorTime = element.two.CC.operatorTime+'s'
                            }
                        }else{
                            element.two.CC.operatorTime='-s'
                        }
                        if(element.two.SP.equipmentTime){
                            if(element.two.SP.equipmentTime>=300){
                                element.two.SP.equipmentTime = _this.s_to_hs(element.two.SP.equipmentTime)
                            }else{
                                element.two.SP.equipmentTime = element.two.SP.equipmentTime+'s'
                            }
                        }else{
                            element.two.SP.equipmentTime='-s'
                        }
                        if(element.two.SP.operatorTime){
                            if(element.two.SP.operatorTime>=300){
                                element.two.SP.operatorTime = _this.s_to_hs(element.two.SP.operatorTime)
                            }else{
                                element.two.SP.operatorTime = element.two.SP.operatorTime+'s'
                            }
                        }else{
                            element.two.SP.operatorTime='-s'
                        }
                        if(element.two.SP.rollingTime){
                            if(element.two.SP.rollingTime>=300){
                                element.two.SP.rollingTime = _this.s_to_hs(element.two.SP.rollingTime)
                            }else{
                                element.two.SP.rollingTime = element.two.SP.rollingTime+'s'
                            }
                        }else{
                            element.two.SP.rollingTime='-s'
                        }
                    })
                    _this.fullscreenLoading = false
                    // for(let a=0;a<_this.tableData.length;a++){
                    //     _this.tableData.splice(a, 0, _this.tableData[a]);  
                    // }
                }else{
                    _this.fullscreenLoading = false
                    _this.$message.error(res.data.msg);
                }
            })
        },
        // 获取规格列表
        getRecipeList(){
            let _this = this
            this.recipeList=[]
            this.selectRecipe=[{label:"全部",value:''}]
            this.choosedRecipe=''
            this.loading=true
            let recipeData={startDate: this.startTimePicker,endDate:this.endTimePicker,language:this.$store.state.lang}
            if(this.choosedmachine !== null &&this.choosedmachine !== undefined &&this.choosedmachine !== ''){
                let key5 = "machineIds";
                recipeData[key5] = this.choosedmachine;
            }
            this.axios({
                method: 'get',
                url: '/url/getRecipeList',
                params: recipeData
            }).then(function(res){
                if (res.data.success === true){
                    // delete res.data.data
                    if('data' in res.data){
                        if(res.data.data.length==0){
                            _this.noRecord=2
                        }else{
                            _this.noRecord=0
                            let recipeContent=res.data.data
                            for(let j = 0; j < recipeContent.length; j++) {
                                let recipeInfo={label:recipeContent[j],value:j+1}
                                _this.recipeList.push(recipeInfo)
                            }
                        }
                        _this.loading=false
                    }else{
                        _this.noRecord=1
                        _this.loading=false
                    }
                }else{
                    _this.loading=false
                    // _this.$message.error(res.data.msg);
                }
            })  
        },
        //点击筛选规格按钮
        checkRecipeBtn(){
            if (this.datePicker===null || this.datePicker.length === 0) {
                this.$message.error(this.$t('EquipmentEfficiency.error1'));
            }else if(this.selectRecipe.length === 0){
                this.$message.error(this.$t('EquipmentEfficiency.error2'));
            }
        },
        //点击设备
        selectmachineId(item){
           //判断之前选择的是否为全部
            let all = this.selectmachine.some(i=>{
                if(i.label=='全部'||i.label=='All'){
                    return true
                }
            })
            //判断当前选择项,之前是否选过
            let flag = this.selectmachine.some(i=>{
                if(i.value==item.value){
                    return true
                }
            })
            //新增选择项
            if(flag===false){ 
                if(item.value===''){
                    //新增选择为全部
                    this.selectmachine=[]
                    //concat将两个数组合成一个新的,在进行赋值,selectmachine得到一个新的地址存的新值
                    let arr = this.selectmachine.concat([item])
                    this.selectmachine =arr
                    //采用push的方法会直接改变原数组,会污染原数组
                    // this.selectmachine.push(item)
                }else if(all===true){
                    //之前选择的是全部
                    this.selectmachine=[]
                    let arr = this.selectmachine.concat([item])
                    this.selectmachine =arr
                    // this.selectmachine.push(item)
                }else{
                    let arr = this.selectmachine.concat([item])
                    this.selectmachine =arr
                    this.selectmachine.sort(this.compare("value"))
                    // this.selectmachine=this.selectmachine.push(item)
                }
            }else{
                //不直接删除原数组中的项
                let selectmachineList=this.selectmachine.concat([])
                selectmachineList.splice(selectmachineList.indexOf(item), 1)
                this.selectmachine=selectmachineList
                //splice()会改变原本的数组，与push()相似，造成之前选中项随之改变
                // this.selectmachine.splice(selectmachineList.indexOf(item), 1)
                if(this.selectmachine.length===0){
                    this.selectmachine.push(this.all)
                }
            }
        },
        //按属性数字大小给对象数组排序
        compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        },
        //选择设备点击确认
        clickmachine(){
            this.selectBeforeMachine= this.selectmachine
            //为解决应引用传递,采用深拷贝,但调用多次后仍会发生引用传递
            // this.selectBeforeMachine= JSON.parse(JSON.stringify(this.selectmachine))
            this.choosedmachine = this.selectmachine.map(function(obj,index){
                return obj.value;
            }).join(",");
            if(this.datePicker!=null){
                this.getRecipeList()
            }
            this.$refs.popover1.doClose()
        },
        //点击规格
        selectRecipeId(item){
            let allRecipe = this.selectRecipe.some(i=>{
                    if(i.label=='全部'||i.label=='All'){
                        return true
                    }
                })
            let flagRecipe = this.selectRecipe.some(i=>{
                    if(i.value==item.value){
                        return true
                    }
                })
            if(flagRecipe===false){
                if(item.value===''){
                    this.selectRecipe=[]
                    let arr = this.selectRecipe.concat([item])
                    this.selectRecipe =arr
                    // this.selectRecipe.push(item)
                }else if(allRecipe===true){
                    this.selectRecipe=[]
                    let arr = this.selectRecipe.concat([item])
                    this.selectRecipe =arr
                    // this.selectRecipe.push(item)
                }else{
                    let arr = this.selectRecipe.concat([item])
                    this.selectRecipe =arr
                    this.selectRecipe.sort(this.compare("value"))
                    // this.selectRecipe.push(item)
                }
            }else{
                let selectRecipeList=this.selectRecipe.concat([])
                selectRecipeList.splice(selectRecipeList.indexOf(item), 1)
                this.selectRecipe=selectRecipeList
                // this.selectRecipe.splice(this.selectRecipe.indexOf(item), 1)
                if(this.selectRecipe.length===0){
                    this.selectRecipe.push(this.allRecipe)
                }
            }
        },
        //选择设备点击确认
        clickrecipe(){
            this.selectBeforeRecipe=this.selectRecipe
            this.choosedRecipe=this.selectRecipe.map(function(obj,index){
                return obj.label;
            }).join(",");
            this.$refs.popover2.doClose()
        }
    }
}
</script>
<style scoped>
.EquipmentEfficiency{
  min-width: 1000px!important;
  display: flex;
}
.mainWrao{
  min-width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
  padding-bottom: 10px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  display: inline-block;
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
}
.tableWrap{
  box-sizing: border-box;
  margin: 10px 15px;
  display:flex;
  justify-content:space-between;
  align-items:center;
}
.times{
    display:flex;
}
.chooseButton{
    margin-left: 20px;
    display: flex;
}
.noMachine{
    text-align: center;
    line-height: 70px;
    color: #909399;
}
.machineList{
   display: flex;
   flex-wrap: wrap;
}
.machineList li{
  width: 150px;
  margin: 0 5px;
  text-align: center;
  height: 24px;
  line-height: 24px;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.25);
  border:1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 10px;
  font-size: 13px;
  cursor: pointer;
  overflow:hidden;
  padding:0 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing:border-box;
}
.machineList.recipeList li{
  width: 95%;
  text-align: left;
}
.active{
  color:#fff;
  background: #66b1ff;
}
.ccbox{
    width: 50%;
    text-align: center;
    display: inline-block;
}
.ccboxRight{
    width: 45%;
    text-align: center;
    display: inline-block;
    border-left: 1px solid #EBEEF5;
}
.newGtime{
    width: 33%;
}
.EquipmentEfficiencyTable{
    height: 70vh;
}
</style>